import { render, staticRenderFns } from "./AmbulanciasReservacionesListado.vue?vue&type=template&id=11a2b892"
import script from "./AmbulanciasReservacionesListado.vue?vue&type=script&lang=js"
export * from "./AmbulanciasReservacionesListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports